// extracted by mini-css-extract-plugin
export var smallSpinner = "_qp-0";